import React from 'react';

import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';
import InputAdornment from '@material-ui/core/InputAdornment';
import { makeStyles, withStyles } from '@material-ui/core/styles';

import ArrowIcon from '@material-ui/icons/KeyboardArrowDown';

const useStyles = makeStyles((theme) => ({
  formControl: {
    width: '100%',
    background: 'var(--app-input-bg)',
    color: theme.palette.text.primary,
    border: 'none',
    borderRadius: '16px',
    outline: 'none',
    minWidth: 120,
    height: '60px',
    '&:active': {
      outline: 'none',
      border: 'none',
      borderRadius: '16px',
    },
    '&:focus': {
      outline: 'none !important',
      border: 'none',
      borderRadius: '16px',
    },
    '&:before': {
      outline: 'none',
      border: 'none',
      borderRadius: '16px',
    },
  },
  select: {
    padding: '0 !important',
    // zIndex: 30,
  },
  endAdornmentContainer: {
    position: 'absolute',
    right: '28px',
    top: 'calc(50% - 2px)',
  },
  endAdornment: {
    color: theme.palette.text.secondary,
    cursor: 'pointer',
  }
}));

const StyledSelect = withStyles((theme) => ({
  root: {
    paddingLeft: '16px !important',
    paddingRight: '0 !important',
    height: '100% !important',
    lineHeight: '58px !important',
    zIndex: '10',
    color: theme.palette.text.primary,
    '&.Mui-disabled': {
      color: `${theme.palette.text.disabled} !important`
    }
  },
  icon: {
    color: theme.palette.text.secondary,
  },
  filled: {
    paddingRight: '24px !important',
    fontWeight: 'bold !important',
    transition: 'none !important',
    background: 'none !important',
    outline: 'none',
    '&:active': {
      outline: 'none',
      borderRadius: '16px',
    },
    '&:focus': {
      outline: 'none !important',
      borderRadius: '16px',
    },
    '&:before': {
      outline: 'none',
      borderRadius: '16px',
    }
  },
  selectMenu: {
    borderRadius: '16px',
  }
}))(Select);

const StyledMenuItem = withStyles((theme) => ({
  root: {
    paddingTop: '12px',
    paddingBottom: '12px',
    width: props => props?.width ? props.width : '500px',
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.background.paper,
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
    '&.Mui-selected': {
      backgroundColor: theme.palette.action.hover,
    },
    '&.Mui-selected:hover': {
      backgroundColor: theme.palette.action.hover,
    }
  }
}))(MenuItem);

const SelectComponent = (props) => {
  const {
    value,
    onChange,
    options = [],
    label,
    defaultLabel,
    name,
    width,
    endAdornment = '',
    disabled = false,
    backgroundColor,
    fontSize,
    borderColor,
  } = props;

  const classes = useStyles();

  return (
    <FormControl
      variant='filled'
      className={classes.formControl}
      style={{
        maxWidth: width || '100%',
        backgroundColor: backgroundColor || 'var(--app-input-bg)',
      }}
    >
      <StyledSelect
        style={borderColor ? {
          fontSize: fontSize || '14px',
          border: `1px solid ${borderColor}`,
        } : {
          fontSize: fontSize || '14px',
        }}
        labelId='select-id'
        id='select-id'
        name={name}
        className={classes.select}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        label={label}
        displayEmpty
        disabled={disabled}
        IconComponent={ArrowIcon}
        endAdornment={endAdornment && (
          <InputAdornment position='end' className={classes.endAdornmentContainer}>
            <span className={classes.endAdornment}>{endAdornment}</span>
          </InputAdornment>
        )}
      >
        {defaultLabel && (<StyledMenuItem value=''>{defaultLabel}</StyledMenuItem>)}
        {options.map((option) => (
          <StyledMenuItem key={option.value} width={width} value={option.value}>
            { option.icon ? (
              <div className='d-flex'>
                {option.icon}
                <span className='m-l-md'>{option.label}</span>
              </div>
            ) : option.label}
          </StyledMenuItem>
        ))}
      </StyledSelect>
    </FormControl>
  );
};

export default SelectComponent;
